module.exports = __webpack_public_path__ + "img/overflow-waterway-chart-top.2e111660.png";